import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _TaxPosition } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { FileInput } from "../../../../../../theme/Component/FileInput";



export const TaxPosition = () => {

    const TaxPosition = useDataBean(_TaxPosition);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [lista, setLista] = useState<any>([]);
    const [TaxCode, setTaxCode] = useState<any>(null)
    const [TaxDescription, setTaxDescription] = useState<any>(null)
    const [modalimp, setModalimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

  const getLista = () => {

    const filters = {
        ...(TaxCode?.trim() && { 
            TaxCode: `%${TaxCode}%` 
        }),

        ...(TaxDescription?.trim() && { 
            TaxDescription: `%${TaxDescription}%` 
        }),
    };

    TaxPosition.instance.getTaxPositionRender(
        paginador.page,
        15,
        filters
    ).then(
        (resp: any) => {
            if (resp) {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15);
                setLista(resp.List);
            }
        }
    )
}

    const create = () => {
        TaxPosition.setBean({
            State: 1,
            IDEmployee: single.getAccountID(),
            Since: single.getCurrenDate()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        TaxPosition.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        TaxPosition.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
      const importArancel = () => {
             if (!TaxPosition.bean.Media) {
            toast.warning("Debe seleccionar un Archivo.");
            return;
        }
            TaxPosition.instance.importArancel(_single.getAccountID(), TaxPosition.bean.Media, TaxPosition.bean.MediaContext).then(
              (resp: any) => {
                console.log(resp)
                setModalimp({ ...modalimp, "view": false });
              }
            ).catch(err => {
              toast.error(err);
            })
        
          }
const verimp = () => {
    
setModalimp({ ...modalimp, "view": true });
    }
    const head = [
        { title: 'ID', property: 'IDTaxPosition', visible: true },
        { title: 'Código Arancel', property: 'TaxCode', visible: true },
        { title: 'Nombre', property: 'TaxDescription', visible: true },
        { title: 'Porcentaje (%)', property: 'TaxPercentage', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${TaxPosition.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Posición Arancel %">
            <div className="row">
                                <div className="col-md-6">
                                    <label>Código fiscal</label>
                                    <input type="text" className="form-control" value={TaxCode} onChange={(e) => { setTaxCode(e.target.value) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Descripción del impuesto</label>
                                    <input type="text" className="form-control" value={TaxDescription} onChange={(e) => { setTaxDescription(e.target.value) }} />
                                </div>
                                <div className="col-md-2 mt-4 p-2">
                                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                                </div>
                                <div className="col-md-4 mt-4 p-2">
                                    <BasicButton icon="ri-bar-chart-grouped-fill" eventClick={verimp}>Importar Aranceles</BasicButton>
                                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={TaxPosition.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="TaxDescription" className="form-control" value={TaxPosition.bean.TaxDescription} onChange={TaxPosition.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Código Arancel</label>
                                <input type="text" name="TaxCode" className="form-control" value={TaxPosition.bean.TaxCode} onChange={TaxPosition.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Porcentaje del Arancel</label>
                                <input type="text" name="TaxPercentage" className="form-control" value={TaxPosition.bean.TaxPercentage} onChange={TaxPosition.handleChange} />
                            </div>
                        </div>
                    </Modal>
                     <Modal modal={modalimp} updateModal={setModalimp} eventModal={importArancel}>
                        <div className="row">
                            <div className="col-md-12">
                                                <FileInput
                                                Media={TaxPosition.bean.Media}
                                                MediaContext={TaxPosition.bean.MediaContext}
                                                directory='Rate'
                                                label='Archivo'
                                                docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                                onCreate={(Filemap: any) => { TaxPosition.setBean({ ...TaxPosition.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                                ></FileInput>
                                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {TaxPosition.bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}